import { render, staticRenderFns } from "./DictionarySave.vue?vue&type=template&id=4f092208&scoped=true"
import script from "./DictionarySave.vue?vue&type=script&lang=js"
export * from "./DictionarySave.vue?vue&type=script&lang=js"
import style0 from "./DictionarySave.vue?vue&type=style&index=0&id=4f092208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f092208",
  null
  
)

export default component.exports